import React from 'react';
import { CheckIcon } from 'lucide-react';
import { competencies } from '../data/profile';
import { SectionHeading } from '../components/SectionHeading';
export function Expertise() {
  return <section className="min-h-[70vh] bg-white pt-32 pb-24 lg:pb-32" data-id="element-159" data-mp="24aixw04p5mg6">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10" data-id="element-160" data-mp="24devtogjob4m">
        <SectionHeading eyebrow="CORE COMPETENCIES" title="Where the transformation work happens" intro="Six areas of enterprise capability, applied across financial services, asset management, hospitality, and consumer packaged goods." data-id="element-161" data-mp="298u9afan450i" />

        <ul className="mt-14 grid gap-px bg-ink/10 md:grid-cols-2 xl:grid-cols-3" data-id="element-162" data-mp="1lkb96n1quyji">
          {competencies.map((item, index) => <li key={item.title} className="group flex flex-col bg-white p-9 transition-colors duration-150 ease-exec hover:bg-grass-50" data-id="element-163" data-mp="1ql8o8qrgjcgs" data-mpi={index}>
              <span className="text-sm tracking-wider2 text-gold-500" data-id="element-164" data-mp="31xhxojqoraia">
                {String(index + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-4 text-2xl leading-snug text-ink" data-id="element-165" data-mp="1x3wdjcumn9xa">{item.title}</h3>
              <p className="mt-4 text-base leading-relaxed text-slate-600" data-id="element-166" data-mp="1s52z9i7inew2">{item.copy}</p>
              <ul className="mt-auto space-y-2 pt-7" data-id="element-167" data-mp="1o3r6j3tcidjn">
                {item.points.map(point => <li key={point} className="flex items-start gap-2 text-base text-grass-700" data-id="element-168" data-mp="1j67u89g7kauc">
                    <CheckIcon className="mt-1 h-4 w-4 flex-none text-grass-500" data-id="element-169" data-mp="1e8pgm5r8x7g0" />
                    <span data-id="element-170" data-mp="19fwezqr2qf85">{point}</span>
                  </li>)}
              </ul>
            </li>)}
        </ul>
      </div>
    </section>;
}